export default [
  {
    path: '/distribution',
    name: 'distribution',
    component: () => import('@views/distribution/index.vue'),
    meta: {
      title: '招工'
    }
  },
  {
    path: '/distributionDetail',
    name: 'distributionDetail',
    component: () => import('@views/distribution/distributionDetail.vue'),
    meta: {
      title: '派活详情页面'
    }
  },
  {
    path: '/invitationBids/publishPage',
    name: 'publishPage',
    component: () => import('@views/invitationBids/publishPage.vue'),
    meta: {
      title: '派活'
    }
  },
  {
    path: '/projectDetails',
    name: 'projectDetails',
    component: () => import('@views/invitationBids/projectDetails.vue'),
    meta: {
      title: '招标—项目详情'
    }
  },
  {
    path: '/companyDetail',
    name: 'companyDetail',
    component: () => import('@views/invitationBids/companyDetail.vue'),
    meta: {
      title: '招标—队伍信息'
    }
  },
  {
    path: '/candidatePage',
    name: 'candidatePage',
    component: () => import('@views/invitationBids/candidatePage.vue'),
    meta: {
      title: '招标—候选人公示'
    }
  },
  {
    path: '/announcePage',
    name: 'announcePage',
    component: () => import('@views/invitationBids/announcePage.vue'),
    meta: {
      title: '招标—发布公告'
    }
  },
  {
    path: '/entertipPage',
    name: 'entertipPage',
    component: () => import('@views/invitationBids/entertipPage.vue'),
    meta: {
      title: '招标—查看公告'
    }
  },
  {
    path: '/invitationBids/myCompany',
    name: 'myCompany',
    component: () => import('@views/invitationBids/myCompany.vue'),
    meta: {
      title: '已选投标队伍页面'
    }
  },
  {
    path: '/reissuePage',
    name: 'reissuePage',
    component: () => import('@views/invitationBids/reissuePage.vue'),
    meta: {
      title: '重新发布详情'
    }
  },
  {
    path: '/editDraft',
    name: 'editDraft',
    component: () => import('@views/invitationBids/editDraft.vue'),
    meta: {
      title: '派活编辑'
    }
  },
  {
    path: '/editBiaozhunPage',
    name: 'editBiaozhunPage',
    component: () => import('@views/invitationBids/editBiaozhunPage.vue'),
    meta: {
      title: '修改标准草稿'
    }
  },
  {
    path: '/mapLocation',
    name: 'mapLocation',
    component: () => import('@views/invitationBids/mapLocation.vue'),
    meta: {
      title: '地图选址'
    }
  },
  {
    path: '/recruitPublishSuccess',
    name: 'recruitPublishSuccess',
    component: () => import('@views/invitationBids/recruitPublishSuccess.vue'),
    meta: {
      title: '招工信息发布成功页面'
    }
  },
]
